// Single source of truth for HRT schedule slugs and their display labels.
// Onboarding (KnowMenoApp.tsx :1362) writes these slugs into
// profiles.health_profile.hrtSchedule. All read-side surfaces (home-screen
// HRT card, in-app Symptom Intelligence Report, PDF Symptom Intelligence Report) MUST go through the
// helpers below so a slug rename is a one-file change.

export const HRT_SCHEDULE_SLUGS = [
  "morning",
  "evening",
  "twice-daily",
  "twice-weekly",
  "weekly",
  "other",
] as const;

export type HrtScheduleSlug = (typeof HRT_SCHEDULE_SLUGS)[number];

const DOCTOR_REPORT_LABELS: Record<HrtScheduleSlug, string> = {
  "morning": "Morning daily",
  "evening": "Evening daily",
  "twice-daily": "Twice daily",
  "twice-weekly": "Twice weekly (patch)",
  "weekly": "Weekly",
  "other": "Variable",
};

const DAILY_CHECKIN_LABELS: Record<HrtScheduleSlug, string> = {
  "morning": "Morning dose",
  "evening": "Evening dose",
  "twice-daily": "Today's doses",
  "twice-weekly": "This dose (patch)",
  "weekly": "This week's dose",
  "other": "Today's dose",
};

function isSlug(v: unknown): v is HrtScheduleSlug {
  return typeof v === "string" && (HRT_SCHEDULE_SLUGS as readonly string[]).includes(v);
}

// For the Symptom Intelligence Report (PDF + in-app Treatment & Adherence).
export function formatHrtSchedule(slug: unknown): string {
  return isSlug(slug) ? DOCTOR_REPORT_LABELS[slug] : "Not specified";
}

// For the home-screen daily HRT check-in card.
export function formatHrtCheckinLabel(slug: unknown): string {
  return isSlug(slug) ? DAILY_CHECKIN_LABELS[slug] : "Today's dose";
}
